module.exports = __webpack_public_path__ + "img/mi-logo-250.bbd46d7c.png";